import React from 'react';

import { gsap } from 'gsap';

// styles
import './allQuestionButton.scss';

const AllQuestionButton = () => {
  const handleClick = (e) => {
    const anchor = '#chart-questions';

    gsap.to(window, {
      duration: 1,
      scrollTo: anchor,
      onComplete: () => {
        location.hash = anchor;
      },
    });
  };

  return (
    <a href="javascript:void(0)" onClick={handleClick} className="allQuestionButton">
      ALLE FRAGEN
    </a>
  );
};

export default AllQuestionButton;
